import React from 'react';
import Sidebar from "../../components/sidebar/Sidebar";
import Header from "../../components/header/Header";
import "../../styles/sidebar/sidebar.css";
import "../../styles/analytics/analytics.css";
import AnalyticsChart from '../../components/analytics/AnalyticsChart';
import ScannedRecordsChart from '../../components/analytics/ScannedRecordsChart';

const SupervisorAnalytics = () => {
  return (
    <div className="dashboard-container">
        <Sidebar role="supervisor" />
        <div className="main-content">
          <Header />
            <div className="analytics-container">
              <div className="scanner-operators-chart">
                <div>
                  <AnalyticsChart/>
                </div>
              </div>

              <div className="scanned-records-chart">
                <div>
                  <ScannedRecordsChart/>
                </div>
              </div>
                
            </div>
        </div>
    </div>
  )
}

export default SupervisorAnalytics